import { render, staticRenderFns } from "./SPagination.vue?vue&type=template&id=5bf632b0&scoped=true"
import script from "./sPagination.ts?vue&type=script&lang=ts&external"
export * from "./sPagination.ts?vue&type=script&lang=ts&external"
import style0 from "./SPagination.vue?vue&type=style&index=0&id=5bf632b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf632b0",
  null
  
)

export default component.exports